<app-cyclops-nav></app-cyclops-nav>

<!-- Solutions Page Header with Background Video -->
<section class="cyclops header" id="home">
  <div class="header5-content">
    <div class="cyclops-header bg video-header">
      <!-- 🎥 Background Video -->
      <video autoplay muted loop playsinline class="video-bg">
        <source src="assets/images/7.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="video-dark-overlay"></div>

      <!-- Overlay Content -->
      <div class="video-overlay">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <div class="center-text text-center" style="justify-content: center;">
                <div>
                  <h1>
                    <span class="bold-text">Why cyclops</span>
                  </h1>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="solutions-section" style=" border-left: 5px solid gray">
    <div class="container">
        <section id="whychoose" style="padding: 30px;">
            <div class="service-box">
                <h3 style="color: #b30000;padding-left: 15px;">Why choose us?</h3>
                <ul>
                    <li>• We help them choose the right solution for their exact needs</li>
                    <li>• We reduce risk by using proven, off-the-shelf systems</li>
                    <li>• We save time by working fast and following clear procurement paths </li>
                    <li>• We keep costs under control — no extra development unless it’s truly needed</li>

                </ul>
            </div>
        </section>
        <section id="capability" style="padding: 30px;">
            <div class="service-box">
                <h3 style="color: #b30000;">CAPABILITIES & ADVANTAGES</h3>
                <ul>
                    CYCLOPS supports defense and security programs through every phase — from identifying opportunities
                    to delivering results on the ground.<br> We provide in-country support, manage full project
                    lifecycles, and coordinate directly with end users and government stakeholders.
                    <br>
                    <p style="padding-bottom: 20px;font-weight: bold; padding-top: 20px; color: white;" >Our team offers:</p>
                    <li>• Market development in the United States, CENTOM, SOUTHCOM, EUCOM, AFRICOM, and INDOPACOM</li>
                    <li>• Deep experience navigating U.S. defense export compliance and licensing frameworks</li>
                    <li>• Localization strategies and partnerships with trusted local companies</li>
                    <li>• Field-proven experience in urgent, mission-critical environments
                        We focus on delivering ready-to-use, practical solutions backed by
                    </li>
                    <li style="padding-left: 10px;">long-term operational support.</li>

                </ul>
            </div>
        </section>
        <section id="marketstrategy" style="padding: 30px;">
            <div class="service-box">
                <h3 style="color: #b30000;">REGIONAL MARKET STRATEGY</h3>
                <ul>
                    CYCLOPS is committed to delivering high-quality, field-tested technologies to the Lebanese and
                    regional markets.
                    We link international defense manufacturers directly with end users, provide live demonstrations,
                    and serve as the distributor of record when needed.
                    We partner with premium global defense brands and offer exclusive technologies to deliver advanced,
                    mission-ready solutions for national security.
                    Our in-country presence and trusted local partnerships allow us to offer competitive pricing, fast
                    delivery, and long-term support.


                </ul>
            </div>
        </section>

    </div>
</section>
<app-cyclops-footer></app-cyclops-footer>